import { render, staticRenderFns } from "./ProvisionFeedTankModal.vue?vue&type=template&id=60bebd79&"
import script from "./ProvisionFeedTankModal.vue?vue&type=script&lang=ts&"
export * from "./ProvisionFeedTankModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports